import { RoutePaths } from "@/config/route-paths";
import { AppBreadcrumbsBuilder } from "@/lib/breadcrumbs";
import type { IBreadcrumbItem } from "@cmde/shadcn";
import i18next from "i18next";

export const getSeasonsListBreadcrumbs = ({
  sport,
  customerId,
  customerName,
  organizationId,
  organizationName,
}: {
  customerId: number;
  organizationId: string;
  organizationName: string;
  sport: string;
  customerName?: string;
}): IBreadcrumbItem[] => {
  return AppBreadcrumbsBuilder.start()
    .withSportradar()
    .withStatsAdmin()
    .withCustomer({ customerId, customerName })
    .withOrganization({ customerId, organizationId, organizationName })
    .withBreadcrumb({
      title: i18next.t("seasons.list.breadcrumbs.seasons"),
      href: RoutePaths.seasons.list({ customerId, organizationId, sport }),
    })
    .build();
};
